import get from 'lodash/get';
import { func, oneOfType, string } from 'prop-types';
import React from 'react';
import { Alert } from 'reactstrap';

import { errorShape } from '../../prop-types';

function WarningComponent({ warning, component: Component, ...rest }) {
  const detail = get(warning, ['response', 'data', 'detail']);
  return (
    <Component color="warning" {...rest}>
      {warning.message}
      {detail && <div>{detail}</div>}
    </Component>
  );
}

WarningComponent.propTypes = {
  warning: errorShape.isRequired,
  component: oneOfType([func, string]),
  className: string,
};

WarningComponent.defaultProps = {
  component: Alert,
  className: 'white-space-pre-wrap',
};

export default WarningComponent;
